export default "__VITE_ASSET__PfSYGPQh__"